import * as React from "react";
import TooltipOptions from "@bizform/primereact/components/tooltip/TooltipOptions";
import { Static } from "@bizform/type/decorator/Static.decorator";
import {
    BaseStateModel,
    ComponentElement,
    ComponentElementDisplayMode,
    ComponentElementStatic,
    ComponentEventType
} from "@bizform/type/model/component_element/ComponentElement.model";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { DataType } from "@bizform/type/model/model/DataType.model";
import { ComponentHelper, Debug, ObjectHelper } from "@bizform/helper/dist/js/bizflow/helper.min";
import { ComponentElementClass, ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";
import { AbstractComponentElement } from "../AbstractComponentElement";
import { I18n } from "../../misc/model/I18n.model";
import { Button } from "@bizform/primereact/components/button/Button";
import classNames from "classnames";


type Props = {
    id?: string;
    value?: object;
    type?: string;
    mask?: string;
    slotChar?: string;
    autoClear?: boolean;
    unmask?: boolean;
    style?: object;
    className?: string;
    placeholder?: string;
    size?: number;
    separator?: any;
    eraserButton?: boolean;
    extendInput?: boolean;
    includeSeparator?: boolean;
    pattern?: string;
    showIdx?: string;
    labelClassName?: string;
    labelStyle?: object;
    buttonClassName?: object;
    buttonStyle?: object;
    maxlength?: number;
    tabindex?: number;
    disabled?: boolean;
    readOnly?: boolean;
    name?: string;
    required?: boolean;
    tooltip?: any;
    tooltipOptions?: TooltipOptions;
    onComplete?(e: Event): void;
    onChange?(e: {originalEvent: Event, value: any}): void;

};

type WrappedCompState = {
    // attribute
    value?: any;
    type?: string;
    mask?: string;
    slotChar?: string;
    autoClear?: boolean;
    // unmask?: boolean;
    pattern?: string;
    separator?: any;
    // hiddenIdx?: string;
    showIdx?: string;
    passwordtoggler?: boolean;
    eraserButton?: boolean;
    extendInput?: boolean;
    includeSeparator?: boolean;
    buttonClassName?: object;
    buttonStyle?: object;
    style?: object;
    labelStyle?: object;
    className?: string;
    labelClassName?: string;
    printStyle?: object;
    printClassName?: string;
    placeholder?: string;
    size?: number;
    maxlength?: number;
    tabindex?: number;
    disabled?: boolean;
    readOnly?: boolean;
    name?: string;
    required?: boolean;
    tooltipAttribute?: TooltipOptions & {text?: string};
    useUnmask?: boolean;
    accessibility?: boolean;
    // event
    onChange?(e: ComponentEventType): void;
    onComplete?(e: Event): void;

};

type WrappedFormState = {
    onChange?: string;
    onComplete?: string;
};

type State = BaseStateModel & {
    wrappedCompState: WrappedCompState;
    wrappedFormState: WrappedFormState;
    showPassword;
    h;
};

/**
 * @since 1.2.5
 * @author Chris Park
 * @class BfInputSecurity
 * @description BfunputSecurity component element
 */
@ComponentElementClass()
@Static<ComponentElementStatic<string | number>>()
export class BfInputSecurity extends AbstractComponentElement<Props, State> {
    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_ydlmZUCTCVZuTnyWQszJSo0WJzN60uA",
        category: ComponentCategory.INPUT,
        label: I18n.componentElement.inputsecurity.label,
        description: I18n.componentElement.inputsecurity.description,
        icon: "",
        dataType: [DataType.STRING, DataType.NUMBER, DataType.INTEGER],
        property: null
    };

    focus(): void {
        if (this._inputSecurity && this._inputSecurity.querySelector("input")) {
            this._inputSecurity.querySelector("input").focus();
        }
    }

    setProperty(property: ComponentElementProperty): void {
        try {
            const newState = ComponentHelper.createStateWithProperties<State, ComponentEventType>(
                property,
                this);
            this.setState(newState);
        } catch (e) {
            this.emitDidCatch(e);
        }
    }

    emit(value: string): void {
    }

    emitFormState(value: string): void {
    }

    subscription(value: string): void {
        let data = {}, start = 0;
        let maskData = this._cleanPatternArray();
        if (value) {
            let stringValue = value.toString();
            let idxSum = 0, idxLst = [], changedFormat = false;
            // idxLst - for check separator index
            for (let i = 0; i < maskData.length; i++) {
                idxSum = idxSum + Number(maskData[i]) + (i > 0 ? 1 : 0);
                idxLst.push(idxSum);
            }
            // check right format for separator change
            let beforeSpecial = stringValue[idxLst[0]];
            for (let i = 0; i < idxLst.length; i++) {
                if (stringValue.length > idxLst[i]) {
                    const specialValue = /[^0-9A-Za-z]/gi;
                    // check separator
                    if (!(specialValue.test(stringValue[idxLst[i]])) || stringValue[idxLst[i]] !== beforeSpecial) {
                        changedFormat = true;
                    }
                    beforeSpecial = stringValue[idxLst[i]];
                }
            }
            // remove separator if the format is same
            if (!changedFormat) {
                for (let i = idxLst.length - 1; i > -1; i--) stringValue = stringValue.substring(0, idxLst[i]) + stringValue.substring(idxLst[i] + 1);
            }
            maskData.filter((item, index) => {
                let element;
                if (maskData.length !== index + 1) {
                    element = stringValue.substr(start, Number(item));
                } else {
                    element = stringValue.substr(start);
                }
                start += Number(item);
                return data[index] = element;
            });
        }
        if (ComponentHelper.isNull(value) || (typeof value === "number" && Number.isNaN(value))) {
            maskData.filter((item, index) => {
                return data[index] = "";
            });
            const newState = {
                wrappedCompState: {
                    ...this.state.wrappedCompState,
                    value: data
                }
            };
            this.setState(newState);
        } else if ( typeof value === "object") {
            this.emitSubscriptionReject();
        } else {
            const newState = {
                wrappedCompState: {
                    ...this.state.wrappedCompState,
                    value: data
                }
            };
            this.setState(newState);
        }
    }

    @ReactComponentElementInit(BfInputSecurity)
    static init(): ComponentElement<string | number> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        // proceed something to clean up
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;

    private _inputSecurity: any;
    private _tooltip: Array<any> = [];


    constructor(props?: Props) {
        super(props);

        this.state = {
            show: false,
            displayMode: ComponentElementDisplayMode.INIT,
            wrappedCompState: {value: {}},
            wrappedFormState: {},
            showPassword: false,
            h: 30
        };

        this._onChangeEvent = this._onChangeEvent.bind(this);
        this._onCompleteEvent = this._onCompleteEvent.bind(this);
        this._deleteAll = this._deleteAll.bind(this);
        this._togglePassword = this._togglePassword.bind(this);
        this._setRef = this._setRef.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._cleanPatternArray = this._cleanPatternArray.bind(this);
    }

    componentDidUpdate(): void {
        if (this._inputSecurity) {
            ComponentHelper.tooltip(this._inputSecurity, this.state.wrappedCompState.tooltipAttribute, this._tooltip);
        }
        if (document.getElementById(`bf-data-value-${this.elementId}${0}`) && this.state.wrappedCompState.pattern) {
            let maskData = this._cleanPatternArray();
            maskData.map((item, index) => {
                if (item !== "") {
                    const inputTag = document.getElementById(`bf-data-value-${this.elementId}${index}`);
                    const s = inputTag.getAttribute("style");
                    const h = inputTag.offsetHeight;
                    let mw;
                    if (this.state.wrappedCompState.extendInput) {
                        mw = h !== 30 ? `width: ${Math.max((10 + Number(item) * (h * 0.65)), (10 + (this.state.wrappedCompState.value[index] ? this.state.wrappedCompState.value[index].length : 0) * (h * 0.65)))}px;` : `width: ${Math.max((10 + Number(item) * 11), (10 + (this.state.wrappedCompState.value[index] ? this.state.wrappedCompState.value[index].length : 0) * 11))}px;`;
                    } else {
                        mw = h !== 30 ? `min-width: ${10 + Number(item) * (h * 0.65) }px;` : `min-width: ${10 + Number(item) * 11}px;`;
                    }
                    if (s.indexOf(mw) === -1) {
                        document.getElementById(`bf-data-value-${this.elementId}${index}`).setAttribute("style", `${s} ${mw}`);
                    }
                }
            });
        }
    }

    componentWillUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>) {
        this._removeCustom();
    }

    componentWillUnmount(): void {
        this._removeCustom();
        this._inputSecurity = null;
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        return ObjectHelper.hasDifference(nextState, this.state);
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        this.emitDidCatch(error);
    }

    emitDidCatch(error: Error | any): void {
        Debug.console.error(error);
    }

    emitSubscriptionReject(): void {
    }

    private _onChangeEvent(e: any): void {
        if (e && e.target && e.target.getAttribute("bf-data-value")) {
            const target = e.target.getAttribute("bf-data-value").split(",");
            const index = Number(target[0]);
            const item = Number(target[1]);
            let currentValue = e.target.value;
            if (currentValue.toString().length > item && !this.accessibility) {
                currentValue = currentValue.toString().substring(0, item);
            } else if (currentValue.toString().length > item && this.accessibility) {
                currentValue = currentValue.toString().length > this.state.wrappedCompState.value[index].length ? this.state.wrappedCompState.value[index] : currentValue.toString();
            }
            const newState = {
                wrappedCompState: {
                    ...this.state.wrappedCompState,
                    value: {
                        ...this.state.wrappedCompState.value,
                        [index] : currentValue
                    }
                }
            };
            if (Number(currentValue.toString().length) === item) {
                if (document.getElementById(`bf-data-value-${this.elementId}${Number(index) + 1}`)) {
                    document.getElementById(`bf-data-value-${this.elementId}${Number(index) + 1}`).focus();
                }
            }
            this.setState(newState, this._callbackSetState);
        }
    }

    private _onCompleteEvent(e: ComponentEventType): void {
    }

    private _callbackSetState() {
        if (this.dataType && (this.dataType === DataType.NUMBER || this.dataType === DataType.INTEGER) && this._inputSecurity && typeof this._inputSecurity.getUnmaskedValue === "function") {
            this.emit(this._inputSecurity.getUnmaskedValue());
        } else {
            if (this.state.wrappedCompState.useUnmask && typeof this._inputSecurity.getUnmaskedValue === "function") {
                this.emit(this._inputSecurity.getUnmaskedValue());
            } else {
                let data = "";
                const pattern = this._cleanPatternArray();
                for (let item in this.state.wrappedCompState.value) {
                    let subData = this.state.wrappedCompState.value[item];
                    if (this.state.wrappedCompState.includeSeparator && subData.length === Number(pattern[item]) && Number(item) !== pattern.length - 1) subData += this.state.wrappedCompState.separator;
                    data = data + subData;
                }
                this.emit(data);
            }
        }
    }

    render(): React.ReactNode {
        const {
            show,
            displayMode
        } = this.state;

        if (!show) {
            return null;
        } else {
            switch (displayMode) {
                case ComponentElementDisplayMode.EDIT:
                    return this._render4Edit();
                case ComponentElementDisplayMode.READONLY:
                    return this._render4ReadOnly();
                case ComponentElementDisplayMode.DISABLED:
                    return this._render4Disabled();
                case ComponentElementDisplayMode.PRINT:
                    return this._render4Print();
                default:
                    return null;
            }
        }
    }

    private _render(newProps: Props): React.ReactNode {
        const dataValue = this._makePattern(newProps);
        const toggler = !this.accessibility ? this._eyeToggler(newProps) : null;
        const deleteBtn = !this.accessibility ? this._deleteBtn(newProps) : null;
        delete(newProps["printClassName"]);
        delete(newProps["printStyle"]);
        return (
            <div className={`${newProps.className}`} style={newProps.style}>
                <div className={`${this.state.displayMode === 3 ? "p-disabled" : ""}`} style={{width: "100%", fontSize: "0.75rem", fontFamily: "Open Sans, Helvetica Neue, sans-serif", textDecoration: "none", outline: "medium none", fontWeight: "normal", overflow: "visible", display: "flex", flexWrap: "wrap"}}>
                    <div className="p-inputgroup" style={{display: "inline-flex", flexWrap: "wrap"}} key={`inputSecurity${this.elementId}`} ref ={this._setRef}>
                        {dataValue}
                        {toggler}
                        {deleteBtn}
                    </div>
                </div>
            </div>
        );
    }

    private _deleteBtn(newProps) {
        if (newProps.eraserButton) {
            return (
                <Button
                    id={`${this.elementId}dBtn`}
                    key={"Security" + this.elementId}
                    className={`p-btn-secondary ${newProps.buttonClassName}`}
                    style={{marginBottom: "10px", backgroundColor: "#6c757d", borderColor: "#6c757d", border: "1px solid transparent", minWidth: "32px", ...newProps.buttonStyle}}
                    icon={"fas fa-eraser"}
                    onClick={this._deleteAll}
                />
            );
        } else {
            return null;
        }
    }

    private _deleteAll() {
        if (this.displayMode === ComponentElementDisplayMode.EDIT) {
            let data = {};
            let maskData = this._cleanPatternArray();
            maskData.map((item, index) => {
                if (item !== "") {
                    data[index] = "";
                }
            });
            const newState = {
                wrappedCompState: {
                    ...this.state.wrappedCompState,
                    value : data
                }
            };
            this.setState(newState, this._callbackSetState);
        }
    }

    private _eyeToggler(newProps) {
        if (newProps.passwordtoggler) {
            return (
                <Button
                    id={`${this.elementId}btn`}
                    key={"Security-" + this.elementId}
                    className={`${newProps.buttonClassName}`}
                    style={{width: "auto", marginBottom: "10px", border: "1px solid transparent", minWidth: "32px", ...newProps.buttonStyle}}
                    icon={
                        classNames(
                            `pi`,
                            { "pi-eye": this.state.showPassword},
                            { "pi-eye-slash": !this.state.showPassword}
                        )}
                    onClick={this._togglePassword}
                />
            );
        }
        else {
            return null;
        }
    }

    private _togglePassword() {
        this.setState({
            showPassword: !this.state.showPassword
        });
    }

    private _makePattern(newProps: Props) {
        let maskData = this._cleanPatternArray(newProps);
        let sdx = newProps.showIdx.split(",");
        let separator, finalFlag;
        let dataValue = maskData.map((item, index) => {
            if (item !== "") {
                let inputType = "password";
                if (this.state.showPassword) {
                    inputType = "text";
                } else {
                    for (let i = 0; i < sdx.length; i++) {
                        if (sdx[i] !== "") {
                            if (Number(sdx[i]) === Number(index)) {
                                inputType = "text";
                                break;
                            }
                        }
                    }
                }
                separator = "";
                finalFlag = true;
                let finalStyle = {marginRight: "-1px"};
                if (maskData.length - 1 !== index) {
                    separator = newProps.separator;
                    finalFlag = false;
                    finalStyle = null;
                }
                let inputStyle;
                if (this.state.wrappedCompState.extendInput) {
                    inputStyle = {border: "1px solid #c8c8c8", borderRadius: "3px", width: `${Math.max((10 + Number(item) * 9), (10 + (newProps.value[index] ? newProps.value[index].length : 0) * 9))}px`, textAlign: "center", height: "100%", minHeight: "30px", outlineColor: "#8dcdff", ...newProps.labelStyle, ...finalStyle};
                } else {
                    inputStyle = {border: "1px solid #c8c8c8", borderRadius: "3px", width: `${10 + Number(item) * 9}px`, textAlign: "center", height: "100%", minHeight: "30px", outlineColor: "#8dcdff", ...newProps.labelStyle, ...finalStyle};
                }
                return (
                    <div style={{display: "flex", marginBottom: "10px"}}>
                        <input
                            type={inputType}
                            id={`bf-data-value-${this.elementId}${index}`}
                            key={item + "_" + index}
                            name={`bf-data-value-${this.elementId}${index}`}
                            bf-data-value={[Number(index), Number(item)]}
                            className={newProps.labelClassName}
                            value={newProps.value[index]}
                            style = {inputStyle}
                            onFocus={this._onFocus}
                            onChange={this._onChangeEvent}
                            readOnly={newProps.readOnly || newProps.disabled ? true : false}
                            >
                        </input>
                        {!finalFlag ? <div style={{display: "inline-block", position: "relative", top: "50%", marginTop: "-10px"}}> &nbsp;{separator}&nbsp; </div> : null}
                    </div>
                );
            }
        });
        return dataValue;
    }

    private _onFocus(e?) {
        if (e && e.target && !this.accessibility) {
            const bfTarget = e.target.getAttribute("bf-data-value").split(",");
            const index = Number(bfTarget[0]);
            let maskData = this._cleanPatternArray();
            if (maskData.length === index + 1 && (e.target.value > 0 || e.target.value.length > 0)) {
                const newState = {
                    wrappedCompState: {
                        ...this.state.wrappedCompState,
                        value: {
                            ...this.state.wrappedCompState.value,
                            [index] : e.target.value.substr(0, Number(maskData[index]))
                        }
                    }
                };
                this.setState(newState, this._callbackSetState);
            }
            e.target.select();
        }
    }


    private _render4Edit(): React.ReactNode {
        const newProps = {
            ...this.state.wrappedCompState
        };

        return this._render(newProps);
    }

    private _render4ReadOnly(): React.ReactNode {
        const newProps = {
            ...this.state.wrappedCompState,
            readOnly: true
        };

        return this._render(newProps);
    }

    private _render4Disabled(): React.ReactNode {
        const newProps = {
            ...this.state.wrappedCompState,
            disabled: true
        };

        return this._render(newProps);
    }

    private _render4Print(): React.ReactNode {
        let data = "";
        let separator;
        const pattern = this._cleanPatternArray();
        const sdx = this.state.wrappedCompState.showIdx.length === 0 ? [] : this.state.wrappedCompState.showIdx.split(",");
        for (let item in this.state.wrappedCompState.value) {
            let sFlag = false;
            separator = "";
            if (this.state.showPassword) {
                sFlag = true;
            } else {
                for (let j of sdx) {
                    if (Number(item) === Number(j)) {
                        sFlag = true;
                        break;
                    }
                }
            }
            if (Number(pattern[item]) === this.state.wrappedCompState.value[item].length) {separator = this.state.wrappedCompState.separator; }
            if (sFlag) {
                data += this.state.wrappedCompState.value[item];
            } else {
                for (let word of this.state.wrappedCompState.value[item]) {data += "*"; }
            }
            data += separator;
        }
        if (this.state.wrappedCompState.value !== {} && this.state.wrappedCompState.value[pattern.length - 1]) {
            data = this.state.wrappedCompState.value[pattern.length - 1].length === Number(pattern.slice(-1)) && isNaN(Number(data.slice(-1))) ? data.slice(0, -1) : data;
        }
        return (
            <div ref={this._setRef} style={this.state.wrappedCompState ? {...this.state.wrappedCompState.printStyle} : null} className={`bf-print-mode ${this.state.wrappedCompState ? this.state.wrappedCompState.printClassName : null}`}>
                {this.state.wrappedCompState.value && (this.state.wrappedCompState.value[0] ? data : null)}
            </div>
        );
    }

    private _setRef(ref) {
        if (ref) {
            this._inputSecurity = ref;
            this.readyComponent();
        }
    }

    private _removeCustom(): void {
        ComponentHelper.unbindTooltip(this._tooltip);
    }

    private _cleanPatternArray(newProps?) {
        const originMaskData = (newProps ? newProps : this.state.wrappedCompState).pattern.split(",");
        let maskData = [];
        originMaskData.map((item) => {
            return item !== "" ? maskData.push(item) : null;
        });
        return maskData;
    }
}
